import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _createSuper from '@babel/runtime/helpers/esm/createSuper';
import _wrapNativeSuper from '@babel/runtime/helpers/esm/wrapNativeSuper';

var TRPCClientError = /*#__PURE__*/function (_Error) {
  _inherits(TRPCClientError, _Error);

  var _super = /*#__PURE__*/_createSuper(TRPCClientError);

  /**
   * @deprecated use `cause`
   */

  /**
   * Fatal error - expect no more results after this error
   * Used for when WebSockets disconnect prematurely.
   */
  function TRPCClientError(message, opts) {
    var _opts$cause, _opts$isDone, _opts$result, _opts$result2;

    var _this;

    _classCallCheck(this, TRPCClientError);

    var cause = (_opts$cause = opts.cause) !== null && _opts$cause !== void 0 ? _opts$cause : opts.originalError; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore https://github.com/tc39/proposal-error-cause

    _this = _super.call(this, message, {
      cause: cause
    });
    _this.originalError = void 0;
    _this.cause = void 0;
    _this.shape = void 0;
    _this.data = void 0;
    _this.isDone = void 0;
    _this.isDone = (_opts$isDone = opts.isDone) !== null && _opts$isDone !== void 0 ? _opts$isDone : false;
    _this.cause = _this.originalError = cause;
    _this.shape = (_opts$result = opts.result) === null || _opts$result === void 0 ? void 0 : _opts$result.error;
    _this.data = (_opts$result2 = opts.result) === null || _opts$result2 === void 0 ? void 0 : _opts$result2.error.data;
    _this.name = 'TRPCClientError';
    Object.setPrototypeOf(_assertThisInitialized(_this), TRPCClientError.prototype);
    return _this;
  }

  _createClass(TRPCClientError, null, [{
    key: "from",
    value: function from(result) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!(result instanceof Error)) {
        var _message;

        return new TRPCClientError((_message = result.error.message) !== null && _message !== void 0 ? _message : '', _objectSpread(_objectSpread({}, opts), {}, {
          result: result
        }));
      }

      if (result.name === 'TRPCClientError') {
        return result;
      }

      return new TRPCClientError(result.message, _objectSpread(_objectSpread({}, opts), {}, {
        cause: result,
        result: null
      }));
    }
  }]);

  return TRPCClientError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { TRPCClientError as T };
